// Available pages for event-level system messages
export const EVENT_PAGES = [
    'realtime',
    'crm',
    'event',
    'tickets',
    'courses',
    'attendance',
    'team',
    'design',
    'publish',
    'mailing'
] as const;

// Available pages for account-level system messages
export const ACCOUNT_PAGES = [
    'home',
    'crm',
    'cash'
] as const;

export const getPagesByScope = (scope: 'event' | 'account' | 'all'): readonly string[] => {
    if(scope === 'all') return [];
    return scope === 'event' ? EVENT_PAGES : ACCOUNT_PAGES;
};

